import { queryOptions, useQuery } from '@tanstack/vue-query';
import type {
  ApiHomePage,
  ApiHomePageEntranceBlock,
  ApiHomePageAboutBlock,
  ApiHomePageTeamBlock,
  ApiPaginatedResponse,
} from '@/types';
import { getBlock } from '@/utils/getBlock';

export function homePageQueryOptions() {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'home'] as const,
    queryFn: () => cmsFetch<ApiPaginatedResponse<ApiHomePage>>('/api/pages/', {
      type: 'pages.HomePage',
      fields: '*',
    }),
  });
}

export function useHomePage() {
  const query = useQuery(homePageQueryOptions());

  const page = computed(() => query.data.value?.items?.[0] ?? null);
  const entrance = computed(() => page.value ? getBlock<ApiHomePageEntranceBlock>(page.value.body, 'entrance') : undefined);
  const about = computed(() => page.value ? getBlock<ApiHomePageAboutBlock>(page.value.body, 'about') : undefined);
  const team = computed(() => page.value ? getBlock<ApiHomePageTeamBlock>(page.value.body, 'team') : undefined);

  return { ...query, page, entrance, about, team };
}
